import { isNull } from "util";
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

// Define the store's state and actions
interface AuthState {
    commonContextParams: {
        username: any;
        userId: any;
        roleId: any;
    };
    permissionContext: any;
    setPermissionContext: (permissions: any) => void;
    redirectUrlPostLogin: string | null;
    setUserContext: (name?: string, Id?: number) => void;
    setCommonContextRoleId: (roleId: number) => void;
    logout: () => void;
    setredirectUrlPostLogin: (url: string | null) => void;
}

interface AuthStateWithoutPersist {
    Jwtaccesstoken: string;
    setJWTAccessToken: (token: string) => void;
}

const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            commonContextParams: {
                username: null,
                userId: null,
                roleId: null
            },
            permissionContext: null,
            setPermissionContext: (permissions: any) => {
                set(state => ({
                    permissionContext: permissions
                }));
            },
            redirectUrlPostLogin: null,

            setUserContext: (name: any, Id: any) => {

                set({ commonContextParams: { username: name, userId: Id, roleId: null } });
            },
            setCommonContextRoleId: (role: number) => {
                set(state => ({
                    commonContextParams: {
                        ...state.commonContextParams,
                        roleId: role === 0 ? null : role
                    }
                }));
            },
            setredirectUrlPostLogin: (url: string | null) => set({ redirectUrlPostLogin: url }),

            logout: () => set({ commonContextParams: {username: null, userId: null, roleId: null}, redirectUrlPostLogin: null }), // rememberMe: false, idtoken: '', accessToken: '', externalUrl: null, Jwtaccesstoken: '', Jwtrefershtoken: '' 
        }),
        {
            name: 'auth-storage', // Stored in localStorage
            storage: createJSONStorage(() => localStorage), // Use createJSONStorage for compatibility
        }
    )
);

export const useAppStore = create((set) => ({
  surveyId: 0,

  setSurveyId: (surveyId: number) => set({ surveyId: surveyId }),
}));

const useNonPersistAuthStore = create<AuthStateWithoutPersist>((set) => ({
    Jwtaccesstoken: '',

    setJWTAccessToken: (token: string) => set({ Jwtaccesstoken: token }),
}));

export  {useAuthStore, useNonPersistAuthStore};
